import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileSpreadsheet, LayoutGrid, Plus, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ImportDialog } from "@/components/ImportDialog";
import { WineFormDialog } from "@/components/WineFormDialog";
import { LocationGridForm } from "@/components/LocationGridForm";

const Choice = ({ icon: Icon, title, text, onClick, id }) => (
  <button onClick={onClick} data-testid={id}
    className="text-left rounded-xl border border-[#2E252A] bg-[#161214] p-6 hover:border-[#D4AF37] hover:-translate-y-0.5 transition-[border-color,transform] duration-200">
    <Icon className="w-6 h-6 text-[#D4AF37] mb-4" strokeWidth={1.5} />
    <p className="font-serif text-xl text-[#F5F0EB] mb-1">{title}</p>
    <p className="text-sm text-[#A89F91]">{text}</p>
  </button>
);

export default function CellarSetup() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [step, setStep] = useState("");
  const home = () => navigate("/");

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-8 sm:py-12" data-testid="cellar-setup-page">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-3">New cellar · {user?.cave_name}</p>
      <h2 className="font-serif text-4xl sm:text-5xl text-[#F5F0EB] mb-3">How would you like to start?</h2>
      <p className="text-[#A89F91] mb-10">You can come back to any of these later.</p>
      {step === "grid" ? (
        <div className="rounded-xl border border-[#2E252A] bg-[#161214] p-6 max-w-lg">
          <button onClick={() => setStep("")} className="flex items-center gap-2 text-sm text-[#A89F91] hover:text-[#D4AF37] mb-5" data-testid="setup-back-button"><ArrowLeft className="w-4 h-4" />Back</button>
          <p className="font-serif text-2xl text-[#F5F0EB] mb-5">Cellar layout</p>
          <LocationGridForm onDone={() => setStep("")} />
        </div>
      ) : (
        <div className="grid sm:grid-cols-3 gap-4">
          <Choice id="setup-import-button" icon={FileSpreadsheet} title="Import a wine list" text="Upload an Excel list you already have." onClick={() => setStep("import")} />
          <Choice id="setup-layout-button" icon={LayoutGrid} title="Set up the layout" text="Define columns and shelves to create the locations." onClick={() => setStep("grid")} />
          <Choice id="setup-add-wine-button" icon={Plus} title="Add a wine" text="Go straight to adding wine to the cellar." onClick={() => setStep("wine")} />
        </div>
      )}
      <button onClick={home} className="mt-10 text-sm text-[#6E665D] hover:text-[#D4AF37]" data-testid="setup-skip-button">Skip — go to the cellar</button>
      <ImportDialog open={step === "import"} onOpenChange={(o) => !o && setStep("")} onDone={home} />
      <WineFormDialog open={step === "wine"} onOpenChange={(o) => !o && setStep("")} onSaved={home} />
    </div>
  );
}
